
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from './store';
import { clearSessionExpiredFlag } from './store/slices/auth.slice';
import { useAuth } from '../features/auth/hooks/useAuth';


const AuthRedirectListener: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const authState = useSelector((state: RootState) => state.auth);
  const { isAuthenticated, isLoadingProfile, logout } = useAuth();

  useEffect(() => {
    if (authState.sessionExpired) {
      navigate('/auth#login', { replace: true });
      dispatch(clearSessionExpiredFlag());
      logout()
    }
  }, [authState.sessionExpired, navigate, dispatch]);

  useEffect(() => {
    // Handle session expiration
    if (authState.sessionExpired) {
      return;
    }
    
    // Don't redirect if still loading or not authenticated
    // Let ProtectedRoute handle unauthenticated redirects
    if (isLoadingProfile || !isAuthenticated) {
      return;
    }
    
    // AuthRedirectListener should NOT handle status-based redirects
    // StatusRouter handles all status-based routing
    // This component only handles authentication state changes
  }, [
    authState.sessionExpired,
    isAuthenticated,
    isLoadingProfile,
  ]);

  return null;
};

export default AuthRedirectListener;